import React from "react";
import styled from "styled-components";
import { MdCheckCircle } from "react-icons/md";
import { DatevCloudIcon } from "../StyledComponents/PathwayIcons";

/**
 * "API verbunden" / "Noch nicht verbunden" indicator shown per client row
 * in the Shops/Account overview, matching the DATEV promo mockup.
 */
const ICON_SIZE = { width: "0.9rem", height: "0.9rem", flexShrink: 0 };

export const DatevConnectedBadge = ({ dataCy }) => (
    <ConnectedBadge data-cy={dataCy}>
        <DatevCloudIcon style={ICON_SIZE} />
        API verbunden
        <MdCheckCircle style={{ flexShrink: 0 }} />
    </ConnectedBadge>
);

export const DatevNotConnectedStatus = ({ dataCy }) => (
    <NotConnectedStatus data-cy={dataCy}>
        <MutedDatevCloudIcon style={ICON_SIZE} />
        Noch nicht verbunden
    </NotConnectedStatus>
);

const ConnectedBadge = styled.span`
    display: inline-flex;
    align-items: center;
    gap: var(--gap-s);
    width: max-content;
    background-color: rgba(16, 143, 143, 0.08);
    border: 1px solid rgba(16, 143, 143, 0.28);
    border-radius: 999px;
    padding: 0.2rem 0.6rem;
    color: #0d7676;
    font-weight: 600;
    font-size: 0.85rem;
    white-space: nowrap;
`;

const NotConnectedStatus = styled.span`
    display: inline-flex;
    align-items: center;
    gap: var(--gap-s);
    width: max-content;
    color: #6c757d;
    font-size: 0.85rem;
    white-space: nowrap;
`;

const MutedDatevCloudIcon = styled(DatevCloudIcon)`
    filter: grayscale(1);
    opacity: 0.6;
`;
